"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("./Button.style"));
var _LinkButton = _interopRequireDefault(require("./LinkButton"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["action", "disabled", "id", "children", "capitalization", "fullWidth", "href", "type", "loading", "loadingContent", "medium", "icon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Button = function Button(_ref) {
  var action = _ref.action,
    disabled = _ref.disabled,
    id = _ref.id,
    children = _ref.children,
    capitalization = _ref.capitalization,
    fullWidth = _ref.fullWidth,
    href = _ref.href,
    type = _ref.type,
    loading = _ref.loading,
    loadingContent = _ref.loadingContent,
    medium = _ref.medium,
    icon = _ref.icon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = _Button["default"];
  var componentProperties = {
    variant: type,
    medium: medium,
    disabled: disabled || loading,
    id: id,
    capitalization: capitalization,
    fullWidth: fullWidth
  };
  if (href) {
    Component = _LinkButton["default"];
    componentProperties = _objectSpread({
      href: href
    }, componentProperties);
  }
  var clickHandler = function clickHandler(e) {
    if (typeof action === 'function') action(e);
  };
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, otherProps, componentProperties, {
    onClick: clickHandler
  }), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "button-icon",
    size: otherProps.iconSize || 24,
    icon: icon
  }), loading ? loadingContent : children);
};
Button.defaultProps = {
  action: undefined,
  disabled: false,
  href: undefined,
  loading: false,
  loadingContent: undefined,
  medium: false,
  type: 'primary',
  icon: undefined,
  id: undefined,
  fullWidth: false,
  capitalization: 'capitalize',
  children: null
};
Button.propTypes = {
  /** Action triggered by clicking the button */
  action: _propTypes["default"].func,
  /** Control the capitalization of button text based on css text-transform property */
  capitalization: _propTypes["default"].oneOf(['lowercase', 'capitalize', 'uppercase', 'none', 'inherit']),
  /** Text or html to be displayed inside the button */
  children: _propTypes["default"].node,
  /** Flag to disable the button */
  disabled: _propTypes["default"].bool,
  /** Extend button to full width of the container */
  fullWidth: _propTypes["default"].bool,
  /** A link to navigate to. If provided a link will be rendered. */
  href: _propTypes["default"].string,
  /** Icon class to be inserted inside the button */
  icon: _propTypes["default"].string,
  /** Button id */
  id: _propTypes["default"].string,
  /** Flag to indicate an ongoing action */
  loading: _propTypes["default"].bool,
  /** Node to display while loading */
  loadingContent: _propTypes["default"].node,
  /** Flag for medium button */
  medium: _propTypes["default"].bool,
  /** Button variant */
  type: _propTypes["default"].oneOf(['primary', 'naked', 'link'])
};
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "action": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Action triggered by clicking the button",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to disable the button",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "href": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A link to navigate to. If provided a link will be rendered.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "loading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate an ongoing action",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "loadingContent": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Node to display while loading",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "medium": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag for medium button",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "Button variant",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'naked'",
          "computed": false
        }, {
          "value": "'link'",
          "computed": false
        }]
      },
      "required": false
    },
    "icon": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Icon class to be inserted inside the button",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Button id",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "fullWidth": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Extend button to full width of the container",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "capitalization": {
      "defaultValue": {
        "value": "'capitalize'",
        "computed": false
      },
      "description": "Control the capitalization of button text based on css text-transform property",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'lowercase'",
          "computed": false
        }, {
          "value": "'capitalize'",
          "computed": false
        }, {
          "value": "'uppercase'",
          "computed": false
        }, {
          "value": "'none'",
          "computed": false
        }, {
          "value": "'inherit'",
          "computed": false
        }]
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Text or html to be displayed inside the button",
      "type": {
        "name": "node"
      },
      "required": false
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(Button);
exports["default"] = _default;